import React, { useEffect } from 'react';
import { useData } from 'src/contexts/DataContext';
import {
  Container,
  StyledBreadcrumbs,
  StyledMainTitle,
  PrinterSectionContainer,
  ImageContainer,
  PrinterDetailsContainer,
  PrinterModelsContainer,
  FAQContainer
} from './styles';
import FAQs from '../FAQs';
import ImageGallery from '../ImageGallery/ImageGallery';
import OtherPrinterComponent from '../OtherPrinterComponent/OtherPrinterComponent';
import DOMPurify from 'dompurify';
import { PrinterItem } from 'src/utils/Products/productFilter';
import RecommendedPrinterComponent from '../RecommendedPrinterComponent/RecommendedPrinterComponent';
import { useTranslationWithInterpolation } from 'src/hooks/useTranslationWithValues/useTranslationWithValuesHelper';

interface PrinterSelectionProps {
  selectedPrinterSku?: (printerName?: string) => void;
  nonCurrentPrinterDetails?: PrinterItem[];
  currentPrinterDetails?: PrinterItem[];
}

const PrinterSelectionComponent = ({
  selectedPrinterSku,
  nonCurrentPrinterDetails,
  currentPrinterDetails
}: PrinterSelectionProps): JSX.Element => {
  const dataContext = useData();
  const { setSelectedPrinterSku } = dataContext || {};

  useEffect(() => {
    if (setSelectedPrinterSku && selectedPrinterSku) {
      setSelectedPrinterSku(() => selectedPrinterSku);
    }
  }, [selectedPrinterSku, setSelectedPrinterSku]);

  const recommendedPrinter = nonCurrentPrinterDetails?.find(
    (p: PrinterItem) => p.recommendedPrinter === true
  );
  const { getText, getTextWithValues } = useTranslationWithInterpolation();
  const sanitizedainTitle = DOMPurify.sanitize(
    getTextWithValues(
      'mainTitle',
      'Upgrade to a <span>tank printer</span>to make the most out of your HP All-In Plan',
      { printer: recommendedPrinter?.printerName }
    )
  );
  return (
    <Container>
      <StyledBreadcrumbs>
        {getText('step1Of2', 'Step 1 of 2')}
      </StyledBreadcrumbs>
      <StyledMainTitle
        role="heading"
        aria-level={1}
        data-testid="headerTitle"
      >
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizedainTitle
          }}
        />
      </StyledMainTitle>
      <PrinterSectionContainer>
        <ImageContainer>
          <ImageGallery nonCurrentPrinterDetails={nonCurrentPrinterDetails} />
        </ImageContainer>
        <PrinterDetailsContainer>
          <RecommendedPrinterComponent
            nonCurrentPrinterDetails={nonCurrentPrinterDetails}
            currentPrinterDetails={currentPrinterDetails}
          />
        </PrinterDetailsContainer>
      </PrinterSectionContainer>
      <PrinterModelsContainer>
        <OtherPrinterComponent
          nonCurrentPrinterDetails={nonCurrentPrinterDetails}
          currentPrinterDetails={currentPrinterDetails}
        />
      </PrinterModelsContainer>
      <FAQContainer>
        <FAQs />
      </FAQContainer>
    </Container>
  );
};

export default PrinterSelectionComponent;
